import { GlobalAction } from '../../interfaces/GlobalAction';
import { MessageDetailsPageState } from '../../interfaces/MessageDetailsPageState';
import { SetModificationMode, SET_MODIFICATION_MODE } from './MessageDetailsPage.actions';

const messageDetailsPageReducer = (state: MessageDetailsPageState, action: GlobalAction): MessageDetailsPageState => {
  switch (action.type) {
    case SET_MODIFICATION_MODE:
      return setModificationMode(state, action);
    default:
      return state;
  }
};

const setModificationMode = (state: MessageDetailsPageState, action: SetModificationMode): MessageDetailsPageState => ({
  ...state,
  modificationMode: action.modificationMode,
});

export default messageDetailsPageReducer;
